import React from 'react';
import StatusBarTemplate from '../layouts/StatusBarTemplate';
import useServerData from '../../hooks/useServerData';
function StatusBar() {
  const [token, consumerData] = useServerData();
  return /*#__PURE__*/React.createElement(StatusBarTemplate, {
    tokenId: token
  });
}
export default StatusBar;